export class MobileWorkAgreementFieldParameter {
  required: boolean | undefined;
}
